import React from 'react';

import AddLinkForm from 'components/dashboard/links-content/AddLinkForm';
import AddHeader from 'components/dashboard/links-content/AddHeader';
import LinkItemsList from 'components/dashboard/links-content/LinkItemsList';

import './LinksPageContent.css';


const LinksPageContent = () => (
  <div className="dashboard-links-page-content__component">
    <div className="add-link-form">
      <AddLinkForm />
      <AddHeader />
    </div>

    <div className="link-list">
      <LinkItemsList />
    </div>
  </div>
);

export default LinksPageContent;
